import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { request_list } from 'store/modules/my_account_store/actions';
import { MyAccountState } from 'store/modules/my_account_store/types';
import Loader from 'components/atoms/loader';
import 'moment/locale/pt-br';
import moment from 'moment';

const MyAccountSolicitation = () => {
  const dispatch = useDispatch();
  moment.locale('pt-br');

  useEffect(() => {
    dispatch(request_list());
  }, []);

  const { my_account, request } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            {request.solicitation_list.loading ? (
              <Loader />
            ) : (
              <div className="card-body">
                <h3 className="card-title">Solicitações</h3>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr className="mt-3">
                        <th scope="col">Protocolo</th>
                        <th scope="col">Solicitação</th>
                        <th scope="col">Data da solicitação</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {my_account?.solicitation_list?.map((call) => (
                        <tr>
                          <td>{call?.protocolo}</td>
                          <td>{call?.protocolo}</td>
                          <td>{`${moment.parseZone(call?.created).format('L LT')}`}</td>
                          <td>
                            <span
                              className={`badge  ${
                                call?.status_id === 4 ? 'badge-success' : 'badge-secondary'
                              }`}
                            >
                              {call?.status_id === 4 ? 'Concluído' : 'Pendente'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {!my_account?.solicitation_list && (
                  <div className="alert alert-warning text-center" role="alert">
                    Nenhuma solicitação
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyAccountSolicitation;
